import { Fraction } from 'bi-fraction';
import { ERC20 as ERC20Abi, LiquidCro as LiquidCroAbi, PrelaunchDepositCronosEvm as PrelaunchDepositAbi, } from './abis';
import { PrelaunchDepositCronosEvm } from './contracts/prelaunchDepositCronosEvm';
import { ChainLayer } from './types';
import { getContract, getProvider } from './utils';
export class SDK_CronosEvm {
    constructor(providerOptions, contractAddressMap) {
        this.providerOptions = providerOptions;
        this.contractAddressMap = contractAddressMap;
        this.getContract = (address, abi, signerOrProvider) => {
            if (!signerOrProvider) {
                signerOrProvider = getProvider(this.providerOptions, ChainLayer.L1);
            }
            return getContract(address, abi, signerOrProvider);
        };
        this.getContractAddress = (contractName) => {
            return this.contractAddressMap[contractName];
        };
        this.getERC20 = (address, signerOrProvider) => this.getContract(address, ERC20Abi, signerOrProvider);
        this.getPrelaunchDeposit = (signerOrProvider) => new PrelaunchDepositCronosEvm(this.getContract(this.getContractAddress('PrelaunchDeposit'), PrelaunchDepositAbi, signerOrProvider), this.getERC20(this.getContractAddress('LiquidCro'), signerOrProvider), this.providerOptions);
        this.getNativeTokenBalance = async (address) => {
            const provider = getProvider(this.providerOptions, ChainLayer.L1);
            const balance = await provider.getBalance(address);
            return new Fraction(balance).shr(18);
        };
        this.getLiquidCroContract = (signerOrProvider) => this.getContract(this.getContractAddress('LiquidCro'), LiquidCroAbi, signerOrProvider);
    }
    toJSON() {
        return JSON.stringify({
            chainId: this.providerOptions.chainId,
        });
    }
}
